/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from './redux/cartActions';
import {Table, Tbody, Thead, Th, Tr, Td} from 'reactable';
import {
  FormGroup,
  Container,
  Input,
  Label,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalFooter
} from '../Common/reactstrap/lib/index';
import config from 'src/config';
import {declinationByNumber} from 'src/logic/utils';
import TableItemQuantity from '../Cart/elements/tableElements/TableItemQuantity';
import CartComponent from '../Cart/CartComponent';

class ModalAddCart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      comment: '',
      quantity: 0
    };
    this.toggle = this.toggle.bind(this);
    this.changeToCartItemQuantity = this.changeToCartItemQuantity.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState){
    return nextState != this.state;
  }
  toggle() {
    let quantity = this.props.data.offer.partion == 0 ? 1 : this.props.data.offer.partion;
    this.setState({
      modal: !this.state.modal,
      quantity: quantity
    });

  }
  addItemToCart(data) {
    this.props.actions.updateCart(data);
    this.toggle();
  }

  changeInputValue(value) {
    this.setState({
      ...value
    });
  }
  changeToCartItemQuantity(quantity, oDI){
    this.setState({
      quantity
    })
  }
  render() {
    //console.log('up');
    let { data} = this.props,
      count = this.props.cartData.cartItems ? this.props.cartData.cartItems.length : 0,
      item = {
        cartId: count, // for guest
        comment: this.state.comment,
        detailId: data.detail.detailId,
        detailName: data.detail.name,
        detailDescription: data.description,
        detailArticle: data.detail.article,
        brandName: data.detail.brandName,
        quantity: this.state.quantity,
        price: data.offer.price,
        logo: data.offer.priceLogo,
        rating: data.offer.rating,
        deliveryTerms: data.offer.deliveryTerms,
        partion: data.offer.partion,
        offer: {
          offerId: data.offer.offerId,
          quantity: data.offer.quantity
        }
      },
      table = (
        <Table className="table" style={{width: '100%'}}>
          <Tr>
            <Td column="Наименование" style={{width: '20%'}}>
              <div>{data.detail.brandName} <br/> {data.detail.article}
              </div>
            </Td>
            <Td column="Описание" style={{width: '40%', paddingRight: '30px'}}>
              {data.detail.name}
            </Td>
            <Td column="Кол-во, шт." style={{width: '30%'}}>
              <TableItemQuantity
                cartDetailId={data.detail.detailId}
                quantity={this.state.quantity}
                onChange={this.changeToCartItemQuantity}
                partion={data.offer.partion}
                limit={data.offer.quantity}
              />
            </Td>
            <Td column="Цена &#8381;" style={{width: '10%'}}>
              <strong>{data.offer.price.toLocaleString()}</strong>
            </Td>
          </Tr>
        </Table>
      );

    return (
      <div>
        <CartComponent
          colored
          offerId={data.offer.offerId}
          onClick={this.toggle}
        />
        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
          <ModalHeader toggle={this.toggle}> Добавление товара в корзину</ModalHeader>
          <Container>
            <Row>
              <Col>
                Всего в вашей корзине {count} {declinationByNumber(count, ['товар', 'товара', 'товаров'])}. <a
                className="link"
                href={config.routes.basket}>Посмотреть</a>
                {table}
                <Input
                  placeholder="Комментарий к заказу"
                  type="text"
                  onChange={(e) => this.changeInputValue({comment: e.target.value})}/>
              </Col>

            </Row>

          </Container>

          <ModalFooter>
            <Button onClick={() => this.addItemToCart(item)}>В корзину</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

}

export default connect(
  (state) => ({
    cartData: state.cart2Reducer
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
  })
)(ModalAddCart);





/** WEBPACK FOOTER **
 ** ./src/components/Cart/ModalAddCart.jsx
 **/